import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NameEntryModal from '../../NameEntryModal';

class RenameContainerButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
    };
  }

  openModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ modalIsOpen: true });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  renameThisContainer = (newName) => {
    this.props.renameContainer(this.props.containerId, newName);
  };

  render() {
    return (
      <div className="renameContainer">
        <button id="renameContainerButton" className="link" onClick={this.openModal}>
          Rename
        </button>
        <NameEntryModal
          modalIsOpen={this.state.modalIsOpen}
          validate={this.props.validate}
          action={this.renameThisContainer}
          title="Rename Room name"
          verb="Save"
          defaultName={this.props.defaultName}
          closeModal={this.closeModal}
        />
      </div>
    );
  }
}

RenameContainerButton.propTypes = {
  renameContainer: PropTypes.func.isRequired,
  validate: PropTypes.func.isRequired,
  defaultName: PropTypes.string.isRequired,
  containerId: PropTypes.string.isRequired,
};

export default RenameContainerButton;
